import { platformFee, type MinorUnits } from "./money.js";

export interface CalculatorInput {
  model: "one_time" | "subscription";
  views: number;
  ctr: number;
  visitToTrial: number;
  trialToPaid: number;
  averageCheckKopecks: MinorUnits;
  monthlyChurn: number;
  horizonMonths: 3 | 6 | 12;
}

export interface MonthForecast {
  month: number;
  visits: number;
  trials: number;
  newBuyers: number;
  activeSubscribers: number;
  gross: MinorUnits;
  platformFee: MinorUnits;
  sellerNet: MinorUnits;
}

export interface CalculatorResult {
  months: MonthForecast[];
  cumulativeGross: MinorUnits;
  cumulativeFee: MinorUnits;
  cumulativeSeller: MinorUnits;
  assumptions: string[];
}

function pct(n: number): number {
  return n / 100;
}

export function forecast(input: CalculatorInput): CalculatorResult {
  const visits = input.views * pct(input.ctr);
  const trials = visits * pct(input.visitToTrial);
  const newBuyers = trials * pct(input.trialToPaid);
  const months: MonthForecast[] = [];
  let active = 0;
  let cumulativeGross = 0n;
  let cumulativeFee = 0n;
  let cumulativeSeller = 0n;

  for (let m = 1; m <= input.horizonMonths; m += 1) {
    if (input.model === "subscription") {
      active = active * (1 - pct(input.monthlyChurn)) + newBuyers;
    }
    const units = input.model === "one_time" ? newBuyers : active;
    const grossFloat = units * Number(input.averageCheckKopecks);
    const gross = BigInt(Math.round(grossFloat));
    const fee = platformFee(gross, 2000);
    const seller = gross - fee;
    months.push({
      month: m,
      visits,
      trials,
      newBuyers,
      activeSubscribers: input.model === "subscription" ? active : 0,
      gross,
      platformFee: fee,
      sellerNet: seller,
    });
    cumulativeGross += gross;
    cumulativeFee += fee;
    cumulativeSeller += seller;
  }

  return {
    months,
    cumulativeGross,
    cumulativeFee,
    cumulativeSeller,
    assumptions: [
      "просмотры и конверсии остаются одинаковыми каждый месяц",
      "на старте активных подписчиков нет",
      "отток применяется к базе предыдущего месяца",
      "задержка между trial и оплатой не учитывается",
      "возвраты, налоги, реклама и эквайринг не включены",
      "люди округляются только для отображения",
      "денежные значения рассчитываются в копейках",
      "в beta реальные платежи и выплаты не выполняются",
    ],
  };
}

export function displayPeople(n: number): number {
  return Math.round(n);
}
